<div class="m-2">
  <h1 class="text-4xl font-bold">Not Implemented</h1>
  <p>
    This feature is not yet implemented. Please check back later.
  </p>
  <pre class="border-solid border-2 rounded-md p-2 border-gray-200 bg-gray-100 drop-shadow-sm">{{ path }}</pre>
</div>
